<template>
  <div class="wrap">
    <!-- <Header :class="`${fixedHeader ? 'fixedHeader' : 'absoluteHeader'}`" /> -->
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner">
      <!-- <div
        v-for="(item, index) in dataBanner"
        :key="index"
        :height="bannerHeight + 'px'"
      >
        <img
          ref="bannerHeight"
          v-lazy="item.imgBanner"
          @load="imgLoad"
          alt=""
        />
      </div> -->
      <!-- <img src="../../assets/image/rlImage/rlBanner.png" alt="" /> -->
      <img v-lazy="imgObj" alt="" />
    </div>
    <div class="main">
      <!-- 第一 -->
      <div class="first" ref="container">
        <div class="title">
          <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div>
          <p>{{ $t("face.prodTitle1") }}</p>
          <!-- <p>Product advantage</p> -->
          <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="content-box">
            <img src="../../assets/image/rlImage/rl-first-1.png" alt="" />
            <h4>{{ $t("ocr.prodContentTitleSon1") }}</h4>
            <p>{{ $t("ocr.prodContentSon1") }}</p>
            <!-- <h4>High-precision model</h4> -->
            <!-- <p>a million-level face training model</p> -->
          </div>
          <div class="content-box">
            <img src="../../assets/image/rlImage/rl-first-2.png" alt="" />
            <h4>{{ $t("ocr.prodContentTitleSon2") }}</h4>
            <p>{{ $t("ocr.prodContentSon2") }}</p>
            <!-- <h4>Fast response</h4>
            <p>service millisecond level response</p> -->
          </div>
          <div class="content-box">
            <img src="../../assets/image/rlImage/rl-first-3.png" alt="" />
            <h4>{{ $t("ocr.prodContentTitleSon3") }}</h4>
            <p>{{ $t("ocr.prodContentSon3") }}</p>
            <!-- <h4>Strong stability and robustness</h4>
            <p>
              support accurate recognition of different expressions, different
              ages, complex backgrounds and light
            </p> -->
          </div>
        </div>
      </div>
      <!-- 第二 -->
      <div class="second">
        <div class="title">
          <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div>
          <p>{{ $t("face.prodTwoTitle1") }}</p>
          <!-- <p>Product application scenarios</p> -->
          <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second1.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon1") }}</p>
                <!-- <p>Financial business</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon1") }}
                  <!-- Face recognition technology has a broad application prospect
                  in the financial industry, which can be divided into identity
                  verification, intelligent recognition and analysis, business
                  innovation support and other application directions. -->
                </span>
              </div>
            </div>
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second2.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon2") }}</p>
                <!-- <p>Online exams</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon2") }}
                  <!-- To further promote exam fairness, more and more universities
                  are applying face recognition to course exams. -->
                </span>
              </div>
            </div>
          </div>
          <div class="center">
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second3.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon3") }}</p>
                <!-- <p>Smart community</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon3") }}
                  <!-- Face recognition is introduced into the community to help
                  build a modern smart community and make people's urban life
                  more intelligent. -->
                </span>
              </div>
            </div>
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second4.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon4") }}</p>
                <!-- <p>Transportation</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon4") }}
                  <!-- the application of traffic QR code, electronic tag, video
                  monitoring, traffic simulation and other services promotes the
                  development of the transportation industry to the direction of
                  intelligence and information. -->
                </span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second5.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon5") }}</p>
                <!-- <p>Government services</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon5") }}
                  <!-- "Internet + government services", artificial intelligence
                  technologies such as face recognition and voice search have
                  been applied in all aspects of government affairs. -->
                </span>
              </div>
            </div>
            <div class="box">
              <img src="../../assets/image/rlImage/rl-second6.png" alt="" />
              <div class="box-text">
                <p>{{ $t("face.prodTwoContentTitleSon6") }}</p>
                <!-- <p>Hotel accommodation</p> -->
                <span>
                  {{ $t("face.prodTwoContentSon6") }}
                  <!-- Face recognition is the basis of building an intelligent hotel
                  ecosystem. Based on face recognition technology, it can create
                  an overall face brushing ecosystem from check-in to check-out. -->
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三 -->
      <div class="thirdly">
        <!-- <img src="../../assets/image/rlImage/rl-bottomBg.png" alt=""> -->
        <img src="../../assets/image/rlImage/rl-bottomBg.png" alt="" />
        <div class="title">
          <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div>
          <p>{{ $t("face.prodThreeTitle1") }}</p>
          <!-- <p>Product demonstration</p> -->
          <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div>
        </div>
        <div class="picture">
          <img src="../../assets/image/demo-face.gif" alt="" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

// let baner = require("../../assets/image/rlImage/rl-loading.png");

export default {
  name: "Face",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage: "",
      fixedHeader: false,
      // imgObj: {
      //   preLoad: 1,
      //   // loading: baner,
      //   loading:require("../../assets/image/rlImage/rl-loading.png"),
      //   src: require("../../assets/image/rlImage/rlBanner.png"),
      //   error: require("../../assets/image/error.jpg"),
      // },
    };
  },
  computed: {
    imgObj() {
      if(this.launage === "en_US"){
        return {
          preLoad: 1,
          loading:require("../../assets/image/rlImage/rl-loading.png"),
          src: require("../../assets/image/rlImage/rlBanner.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }else{
         return {
          preLoad: 1,
          loading: require("../../assets/zhImage/compress_cn/rlBanner-zh.png"),
          src: require("../../assets/zhImage/product/rlBanner-zh.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }
    },
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  min-height: 400px;
  img {
    width: 100%;
  }
}
.title {
  margin: auto;
  font-size: 32px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  .wire {
    margin-left: 20px;
    margin-right: 20px;
  }
}
.main {
  //第一
  .first {
    background: #fff;
    width: 100%;
    padding-top: 40px;
    .content {
      display: flex;
      justify-content: space-around;
      margin-top: 50px;
      margin-bottom: 83px;
      .content-box {
        width: 340px;
        height: 314px;
        background: #ffffff;
        box-shadow: 0px 4px 24px 0px rgba(29, 56, 69, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        img {
          margin-top: 40px;
        }
        h4 {
          // width: 227px;
          text-align: center;
          margin-top: 23px;
          margin-bottom: 20px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #000000;
          // word-break: break-all; //英文单词不换行
        }
        p {
          width: 334px;
          font-size: 16px;
          text-align: center;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #747474;
          // word-break: break-all;
        }
      }
    }
  }
  .second {
    background: #f8f8f8;
    width: 100%;
    padding-top: 40px;
    .content {
      // width: 90%;
      margin: auto;
      display: flex;
      margin-top: 23px;
      // justify-content: space-around;
      // justify-content: space-evenly;
      justify-content: space-between;
      &:before,
      &:after {
        content: "";
        display: block;
      }
      .box {
        max-width: 380px;
        min-height: 465px;
        margin-bottom: 40px;
        border-radius: 10px;
        background: #ffffff;
        box-shadow: 0px 4px 24px 0px rgba(29, 56, 69, 0.1);
        img {
          width: 100%;
        }
        .box-text {
          padding: 20px;
          p {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
          }
          span {
            display: inline-block;
            margin-top: 8px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #747474;
          }
        }
      }
      .left {
        margin-top: 124px;
      }
      .center {
        margin-top: 42px;
      }
      .right {
        margin-top: 124px;
      }
    }
  }
  .thirdly {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .title {
      position: absolute;
      top: 6%;
      left: 50%;
      transform: translate(-50%, 0);
      color: #fff;
      // margin: auto;
      // z-index: 9999;
    }
    .picture {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -46%);
      img {
        border-radius: 30px;
      }
      // width: 960px;
      // height: 500px;
      // background: #D7D7D7;
      // box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.52);
      // border-radius: 30px;
    }
  }
}
</style>